export const styleIconsFilters = (isSelected = false, hasBorder = false) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    padding: "8px",
    marginRight: hasBorder ? ".5rem" : "0",
    border: hasBorder ? "1px solid #F3F3F3" : "none",
    width: hasBorder ? ".8rem" : "1.5rem",
    height: hasBorder ? ".8rem" : "1.5rem",
    backgroundColor: isSelected && "#aa9e9e60",
  };
};

export const styleFilterIconButton = (filterOpened = false) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "3px",
    padding: "8px",
    width: ".8rem",
    height: ".8rem",
    backgroundColor: filterOpened ? "#aa9e9e60" : "#aa9e9e30",
  };
};

export const styleIconGrid = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingBlock: ".25rem",
};

export const styleGridContainer = {
  padding: ".25rem",
};

export const styleFilterIcon = {
  fontSize: ".8rem",
  color: "#00ccff",
};
